import { Container } from "@mui/material";
import React, { useEffect, useState } from "react";
import { P, SectionHeading, SectionSmallHeading, SectionSubHeading } from "../../Styles/style";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Twitter from "../../../assets/images/twitter.png"
import telegram from "../../../assets/images/telegram.png"
const LockerMenu = (props) => {
  const handleClick = () => {
    const textToCopy = 'Contract';
    navigator.clipboard.writeText(textToCopy);
    toast.success('Contract Copied!');
  };

  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass

    {
      title: <img src={Twitter}/>,
      link: "https://twitter.com/Mini_PepeEth",
      target:"blank",
    },
    {
      title: <img src={telegram}/>,
      link: "https://t.me/MiniPepejoin",
      target:"blank",
    },
    {
      title: "Contract",
      onClick: handleClick,
    },
  ];
  return (
    <>
    <div
      data-aos="fade-zoom-in"
      data-aos-easing="ease-in"
      data-aos-delay="400"
      data-aos-duration="400"
      data-aos-offset="0">
      <DesktopMenu menuList={menuList} />
      <MobileMenu menuList={menuList} />
      <ToastContainer />
    </div>
    </>
  );
};

export default LockerMenu;
